export default {
  '发票开具确认': 'Confirmation of invoice issuance',
  '常规订单': 'Routine orders',
  '订单号': 'Order number',
  '展会': 'Exhibition',
  '展位号': 'Exhibition number',
  '开票金额': 'Invoice amount',
  '商品名称': 'Name of commodity',
  '金额': 'Amount of money',
  '数量': 'Number',
  '费用减免': 'Cost relief',
  '退款金额': 'refund amount',
  '余额': 'balance',
  '付款识别码': 'Remittance_id',
  '现场缴费订单': 'On-site order',
  '以下为现场缴费订单，请正确填写付款识别码方可开具发票': 'The following is the on-site payment order. Please fill in the remittance identification code correctly before invoicing.',
  '注': 'Please fill in the payment identification code. If you do not fill in or make a mistake, you will not be able to issue an invoice for this order.',
  '您还有未确认的现场订单': 'Do you have an unconfirmed on-site order, reconfirmed or not?',
  '提示': 'tips',
  '请选择有效的订单': 'Please select a valid order',
  '返回': 'Back',
  '当前电子普票仅支持': 'The current e-bill only supports the invoice amount below ',
  '元以下的开票金额，超过限额请分批次申请': ' yuan. If it exceeds the limit, please apply in batches',
  '普通发票数量不足': 'The quantity of ordinary invoice is insufficient',
  '增值税专用发票数量不足': 'Insufficient quantity of VAT special invoice',
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/invoiceConfirmation.js